module.exports = __webpack_public_path__ + "img/zixun_3.b190bfe.png";